import { styled } from "@linaria/react";
import { cssDialog } from "@/ui/Modal/StyledModal";
import { cssButtonClearFilters, StyledFilters } from "../StyledFilter";
export const StyledFiltersModals = /*#__PURE__*/styled('section')({
  name: "StyledFiltersModals",
  class: "StyledFiltersModals_s10nloa"
});

require("./StyledFilterModals.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledFilterModals.tsx");